
import { options } from "../../../utils/Data";
import React, { useRef } from 'react';

const AttachmentOptions = ({ attachmentOptionsVisible, handleFileTypeClick, handleButtonClick }) => {
    const fileInputRef = useRef(null);

    const handleClick = (fileType) => {
        handleButtonClick();
        handleFileTypeClick(fileType);
        fileInputRef.current.click(); // Trigger click event on file input
    };

    return (
        <div className={`flex absolute z-10 bottom-16 bg-th-bg p-4 rounded-md shadow-lg mt-2 w-[348px] ${attachmentOptionsVisible ? 'block' : 'hidden'}`}>
            <div className="grid grid-cols-3 gap-2">
                {options.map((option, index) => (
                    <button
                        key={index}
                        type="button"
                        className="p-2 flex flex-col items-center text-sm hover:bg-enabled-btn hover:text-white rounded-md"
                        onClick={() => handleClick(option.type)}
                    >
                        {option.icon}
                        {option.label}
                    </button>
                ))}
            </div>
            <input
                ref={fileInputRef}
                id="fileInput"
                type="file"
                multiple
                // Add appropriate file type accept attributes here
                className="hidden"
            />
        </div>
    );
};

export default AttachmentOptions;


// import { options } from "../../../utils/Data";

// const AttachmentOptions = ({ attachmentOptionsVisible, handleFileTypeClick, handleButtonClick }) => {
//     // const handleClick = (fileType) => {
//     //     handleFileTypeClick(fileType);
//     //     handleButtonClick();
//     // };
//     console.log("Attachment options visible:", attachmentOptionsVisible);

//     // const handleClick = (fileType) => {
//     //     handleButtonClick();
//     //     handleFileTypeClick(fileType);
//     // };
//     const handleClick = (fileType) => {
//         console.log("Option button clicked:", fileType);
//         handleFileTypeClick(fileType);
//         handleButtonClick();
//     };


//     return (
//         <div
//             className={`flex absolute z-10 bottom-16 bg-th-bg p-4 rounded-md shadow-lg mt-2 w-[348px] ${attachmentOptionsVisible ? 'block' : 'hidden'
//                 }`}
//         >
//             <div className="grid grid-cols-3 gap-2">
//                 {options.map((option, index) => (
//                     <button
//                         key={index}
//                         type="button"
//                         className="p-2 flex flex-col items-center text-sm hover:bg-enabled-btn hover:text-white rounded-md"
//                         onClick={() => handleClick(option.type)}
//                     >
//                         {option.icon}
//                         {option.label}
//                     </button>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default AttachmentOptions;



// import React from 'react';
// import {
//     ChatDocumentIcon,
//     ChatCameraIcon,
//     ChatGalleryIcon,
//     ChatAudioIcon,
//     ChatLocationIcon,
//     ChatContactIcon,
// } from '../../../components/common/IconComponents';

// const AttachmentOptions = ({ attachmentOptionsVisible, attachmentOptionsRef, handleFileTypeClick }) => {
//     return (
//         <div
//             className={`flex absolute z-10 bottom-16 bg-th-bg p-4 rounded-md shadow-lg mt-2 w-[348px] ${attachmentOptionsVisible ? 'block' : 'hidden'
//                 }`}
//             ref={attachmentOptionsRef}
//         >
//             <div className="grid grid-cols-3 gap-2">
//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('document')}
//                 >
//                     <ChatDocumentIcon className="mb-1 w-[36px] h-[36px]" />
//                     Document
//                 </button>

//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('camera')}
//                 >
//                     <ChatCameraIcon className="mb-1 w-[36px] h-[36px]" />
//                     Camera
//                 </button>

//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('gallery')}
//                 >
//                     <ChatGalleryIcon className="mb-1 w-[36px] h-[36px]" />
//                     Gallery
//                 </button>

//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('audio')}
//                 >
//                     <ChatAudioIcon className="mb-1 w-[36px] h-[36px]" />
//                     Audio
//                 </button>
//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('location')}
//                 >
//                     <ChatLocationIcon className="mb-1 w-[36px] h-[36px]" />
//                     Location
//                 </button>
//                 <button
//                     type="button"
//                     className="p-2 flex flex-col items-center text-sm"
//                     onClick={() => handleFileTypeClick('contact')}
//                 >
//                     <ChatContactIcon className="mb-1 w-[36px] h-[36px]" />
//                     Contact
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default AttachmentOptions;



// import { ChatDocumentIcon, ChatCameraIcon, ChatGalleryIcon, ChatAudioIcon, ChatLocationIcon, ChatContactIcon, } from '../../../components/common/IconComponents';

// const AttachmentOptions = ({ handleFileTypeClick }) => {
//     return (
//         <div className="grid grid-cols-3 gap-2">
//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('document')}
//             >
//                 <ChatDocumentIcon className="mb-1 w-[36px] h-[36px]" />
//                 Document
//             </button>

//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('camera')}
//             >
//                 <ChatCameraIcon className="mb-1 w-[36px] h-[36px]" />
//                 Camera
//             </button>

//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('gallery')}
//             >
//                 <ChatGalleryIcon className="mb-1 w-[36px] h-[36px]" />
//                 Gallery
//             </button>

//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('audio')}
//             >
//                 <ChatAudioIcon className="mb-1 w-[36px] h-[36px]" />
//                 Audio
//             </button>

//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('location')}
//             >
//                 <ChatLocationIcon className="mb-1 w-[36px] h-[36px]" />
//                 Location
//             </button>

//             <button
//                 type="button"
//                 className="p-2 flex flex-col items-center text-sm hover:bg-gray-100"
//                 onClick={() => handleFileTypeClick('contact')}
//             >
//                 <ChatContactIcon className="mb-1 w-[36px] h-[36px]" />
//                 Contact
//             </button>
//         </div>
//     );
// };

// export default AttachmentOptions;
